var hexTable = function () {
  var array = [];

  for (var i = 0; i < 256; ++i) {
    array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
  }

  return array;
}();

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable$1 = function () {
  var array = [];

  for (var i = 0; i < 256; ++i) {
    array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
  }

  return array;
}();

var compactQueue = function compactQueue(queue) {
  while (queue.length > 1) {
    var item = queue.pop();
    var obj = item.obj[item.prop];

    if (isArray(obj)) {
      var compacted = [];

      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== 'undefined') {
          compacted.push(obj[j]);
        }
      }

      item.obj[item.prop] = compacted;
    }
  }
};

var arrayToObject = function arrayToObject(source, options) {
  var obj = options && options.plainObjects ? Object.create(null) : {};

  for (var i = 0; i < source.length; ++i) {
    if (typeof source[i] !== 'undefined') {
      obj[i] = source[i];
    }
  }

  return obj;
};

var merge = function merge(target, source, options) {
  /* eslint no-param-reassign: 0 */
  if (!source) {
    return target;
  }

  if (typeof source !== 'object') {
    if (isArray(target)) {
      target.push(source);
    } else if (target && typeof target === 'object') {
      if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) {
        target[source] = true;
      }
    } else {
      return [target, source];
    }

    return target;
  }

  if (!target || typeof target !== 'object') {
    return [target].concat(source);
  }

  var mergeTarget = target;

  if (isArray(target) && !isArray(source)) {
    mergeTarget = arrayToObject(target, options);
  }

  if (isArray(target) && isArray(source)) {
    source.forEach(function (item, i) {
      if (has.call(target, i)) {
        var targetItem = target[i];

        if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
          target[i] = merge(targetItem, item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i] = item;
      }
    });
    return target;
  }

  return Object.keys(source).reduce(function (acc, key) {
    var value = source[key];

    if (has.call(acc, key)) {
      acc[key] = merge(acc[key], value, options);
    } else {
      acc[key] = value;
    }

    return acc;
  }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
  return Object.keys(source).reduce(function (acc, key) {
    acc[key] = source[key];
    return acc;
  }, target);
};

var decode = function (str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, ' ');

  if (charset === 'iso-8859-1') {
    // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  } // utf-8


  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};

var encode = function encode(str, defaultEncoder, charset) {
  // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
  // It has been adapted here for stricter adherence to RFC 3986
  if (str.length === 0) {
    return str;
  }

  var string = str;

  if (typeof str === 'symbol') {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== 'string') {
    string = String(str);
  }

  if (charset === 'iso-8859-1') {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
      return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
  }

  var out = '';

  for (var i = 0; i < string.length; ++i) {
    var c = string.charCodeAt(i);

    if (c === 0x2D // -
    || c === 0x2E // .
    || c === 0x5F // _
    || c === 0x7E // ~
    || c >= 0x30 && c <= 0x39 // 0-9
    || c >= 0x41 && c <= 0x5A // a-z
    || c >= 0x61 && c <= 0x7A // A-Z
    ) {
        out += string.charAt(i);
        continue;
      }

    if (c < 0x80) {
      out = out + hexTable$1[c];
      continue;
    }

    if (c < 0x800) {
      out = out + (hexTable$1[0xC0 | c >> 6] + hexTable$1[0x80 | c & 0x3F]);
      continue;
    }

    if (c < 0xD800 || c >= 0xE000) {
      out = out + (hexTable$1[0xE0 | c >> 12] + hexTable$1[0x80 | c >> 6 & 0x3F] + hexTable$1[0x80 | c & 0x3F]);
      continue;
    }

    i += 1;
    c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
    out += hexTable$1[0xF0 | c >> 18] + hexTable$1[0x80 | c >> 12 & 0x3F] + hexTable$1[0x80 | c >> 6 & 0x3F] + hexTable$1[0x80 | c & 0x3F];
  }

  return out;
};

var compact = function compact(value) {
  var queue = [{
    obj: {
      o: value
    },
    prop: 'o'
  }];
  var refs = [];

  for (var i = 0; i < queue.length; ++i) {
    var item = queue[i];
    var obj = item.obj[item.prop];
    var keys = Object.keys(obj);

    for (var j = 0; j < keys.length; ++j) {
      var key = keys[j];
      var val = obj[key];

      if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
        queue.push({
          obj: obj,
          prop: key
        });
        refs.push(val);
      }
    }
  }

  compactQueue(queue);
  return value;
};

var isRegExp = function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
  return [].concat(a, b);
};

var utils = {
  arrayToObject: arrayToObject,
  assign: assign,
  combine: combine,
  compact: compact,
  decode: decode,
  encode: encode,
  isBuffer: isBuffer,
  isRegExp: isRegExp,
  merge: merge
};

var has$1 = Object.prototype.hasOwnProperty;
var isArray$1 = Array.isArray;
var defaults = {
  allowDots: false,
  allowPrototypes: false,
  arrayLimit: 20,
  charset: 'utf-8',
  charsetSentinel: false,
  comma: false,
  decoder: utils.decode,
  delimiter: '&',
  depth: 5,
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1000,
  parseArrays: true,
  plainObjects: false,
  strictNullHandling: false
};

var interpretNumericEntities = function (str) {
  return str.replace(/&#(\d+);/g, function ($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
};

var parseArrayValue = function (val, options) {
  if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
    return val.split(',');
  }

  return val;
}; // This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.


var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.

var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
  var obj = {};
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
  var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
  var parts = cleanStr.split(options.delimiter, limit);
  var skipIndex = -1; // Keep track of where the utf8 sentinel was found

  var i;
  var charset = options.charset;

  if (options.charsetSentinel) {
    for (i = 0; i < parts.length; ++i) {
      if (parts[i].indexOf('utf8=') === 0) {
        if (parts[i] === charsetSentinel) {
          charset = 'utf-8';
        } else if (parts[i] === isoSentinel) {
          charset = 'iso-8859-1';
        }

        skipIndex = i;
        i = parts.length; // The eslint settings do not allow break;
      }
    }
  }

  for (i = 0; i < parts.length; ++i) {
    if (i === skipIndex) {
      continue;
    }

    var part = parts[i];
    var bracketEqualsPos = part.indexOf(']=');
    var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
    var key, val;

    if (pos === -1) {
      key = options.decoder(part, defaults.decoder, charset, 'key');
      val = options.strictNullHandling ? null : '';
    } else {
      key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
      val = options.decoder(part.slice(pos + 1), defaults.decoder, charset, 'value');
    }

    if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
      val = interpretNumericEntities(val);
    }

    val = parseArrayValue(val, options);

    if (part.indexOf('[]=') > -1) {
      val = isArray$1(val) ? [val] : val;
    }

    if (has$1.call(obj, key)) {
      obj[key] = utils.combine(obj[key], val);
    } else {
      obj[key] = val;
    }
  }

  return obj;
};

var parseObject = function (chain, val, options) {
  var leaf = parseArrayValue(val, options);

  for (var i = chain.length - 1; i >= 0; --i) {
    var obj;
    var root = chain[i];

    if (root === '[]' && options.parseArrays) {
      obj = [].concat(leaf);
    } else {
      obj = options.plainObjects ? Object.create(null) : {};
      var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
      var index = parseInt(cleanRoot, 10);

      if (!options.parseArrays && cleanRoot === '') {
        obj = {
          0: leaf
        };
      } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
        obj = [];
        obj[index] = leaf;
      } else {
        obj[cleanRoot] = leaf;
      }
    }

    leaf = obj;
  }

  return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
  if (!givenKey) {
    return;
  } // Transform dot notation to bracket notation


  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey; // The regex chunks

  var brackets = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g; // Get the parent

  var segment = options.depth > 0 && brackets.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key; // Stash the parent if it exists

  var keys = [];

  if (parent) {
    // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
    if (!options.plainObjects && has$1.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(parent);
  } // Loop through children appending to the array until we hit depth


  var i = 0;

  while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
    i += 1;

    if (!options.plainObjects && has$1.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(segment[1]);
  } // If there's a remainder, just add whatever is left


  if (segment) {
    keys.push('[' + key.slice(segment.index) + ']');
  }

  return parseObject(keys, val, options);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
  if (!opts) {
    return defaults;
  }

  if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
    throw new TypeError('Decoder has to be a function.');
  }

  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
  }

  var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
  return {
    allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
    allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
    arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
    charset: charset,
    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
    comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
    decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
    delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults.depth,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
  };
};

var parse = function (str, opts) {
  var options = normalizeParseOptions(opts);

  if (str === '' || str === null || typeof str === 'undefined') {
    return options.plainObjects ? Object.create(null) : {};
  }

  var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
  var obj = options.plainObjects ? Object.create(null) : {}; // Iterate over the keys and setup the new object

  var keys = Object.keys(tempObj);

  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    var newObj = parseKeys(key, tempObj[key], options);
    obj = utils.merge(obj, newObj, options);
  }

  return utils.compact(obj);
};

function compose() {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    if (funcs.length === 0) {
        return function (arg) { return arg; };
    }
    if (funcs.length === 1) {
        return funcs[0];
    }
    return funcs.reduce(function (a, b) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return a(b.apply(void 0, args));
    }; });
}

var client = window &&
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.Client &&
    window.webkit.messageHandlers.Client.postMessage &&
    window.webkit.messageHandlers.Client;
function messageFactory(method, params, outSideParams) {
    if (params === void 0) { params = {}; }
    if (outSideParams === void 0) { outSideParams = {}; }
    var message = Object.assign({
        method: method,
        params: params,
        callback: "loveshow." + method,
    }, outSideParams);
    return function (callback) {
        window[message.callback] = callback;
        if (typeof loveshow === 'undefined') {
            window.loveshow = {};
        }
        loveshow[method] = callback;
        return message;
    };
}
function resultFactory(messageFn, callback) {
    var middlewares = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        middlewares[_i - 2] = arguments[_i];
    }
    return callback
        ? client.postMessage(messageFn(compose.apply(void 0, middlewares)(callback)))
        : new Promise(function (resolve) {
            return client.postMessage(messageFn(compose.apply(void 0, middlewares)(resolve)));
        });
}
function getUid(callback) {
    var formatter = function (callback) { return function (uid) { return callback(parseInt(uid, 10)); }; };
    return resultFactory(messageFactory('getUid'), callback, formatter);
}
function getToken(callback) {
    return resultFactory(messageFactory('getToken'), callback);
}
function openWeChat(callback) {
    return resultFactory(messageFactory('openWeChat'), callback);
}
function follow(followParams, callback) {
    return resultFactory(messageFactory('follow', followParams, followParams), callback);
}
function getParams(callback) {
    var formatter = function (callback) { return function (JsonRes) { return callback(JSON.parse(JsonRes)); }; };
    return resultFactory(messageFactory('getParams'), callback, formatter);
}
function closeWebPage(closeWebPageParams, callback) {
    return resultFactory(messageFactory('closeWebPage'), callback);
}
function share(shareParams, callback) {
    return resultFactory(messageFactory('share', shareParams), callback);
}
function hasVip(callback) {
    var formatter = function (callback) { return function (JsonRes) { return callback(!!(JSON.parse(JsonRes).has_vip)); }; };
    return resultFactory(messageFactory('hasVip'), callback, formatter);
}
function fullScreenTouch(callback) {
    return resultFactory(messageFactory('fullScreenTouch'), callback);
}
function cancelScreenTouch(callback) {
    return resultFactory(messageFactory('cancelScreenTouch'), callback);
}
function clientToast(clientToastParams, callback) {
    return resultFactory(messageFactory('clientToast', clientToastParams), callback);
}
function closeGame(callback) {
    return resultFactory(messageFactory('closeGame'), callback);
}
function sendMsg(sendMsgParams, callback) {
    return resultFactory(messageFactory('sendMsg', sendMsgParams), callback);
}
function showSendGift(showSendGiftParams, callback) {
    return resultFactory(messageFactory('showSendGift', showSendGiftParams), callback);
}
function sharePictureUrl(sharePictureUrlParams, callback) {
    return resultFactory(messageFactory('sharePictureUrl', sharePictureUrlParams), callback);
}
function openNewWebview(openNewWebviewParams, callback) {
    return resultFactory(messageFactory('openNewWebview', openNewWebviewParams), callback);
}
function setHead(callback) {
    return resultFactory(messageFactory('setHead'), callback);
}
function setNickname(callback) {
    return resultFactory(messageFactory('setNickname'), callback);
}
function setTagList(callback) {
    return resultFactory(messageFactory('setTagList'), callback);
}
function setLocation(callback) {
    return resultFactory(messageFactory('setLocation'), callback);
}
function setSignature(callback) {
    return resultFactory(messageFactory('setSignature'), callback);
}
function setRealPersonAuth(callback) {
    return resultFactory(messageFactory('setRealPersonAuth'), callback);
}
function editUserInfo(editUserInfoParams, callback) {
    return resultFactory(messageFactory('editUserInfo', editUserInfoParams), callback);
}
var ios = {
    getUid: getUid,
    getToken: getToken,
    openWeChat: openWeChat,
    follow: follow,
    getParams: getParams,
    closeWebPage: closeWebPage,
    share: share,
    hasVip: hasVip,
    fullScreenTouch: fullScreenTouch,
    cancelScreenTouch: cancelScreenTouch,
    clientToast: clientToast,
    closeGame: closeGame,
    sendMsg: sendMsg,
    showSendGift: showSendGift,
    sharePictureUrl: sharePictureUrl,
    openNewWebview: openNewWebview,
    setHead: setHead,
    setNickname: setNickname,
    setTagList: setTagList,
    setLocation: setLocation,
    setSignature: setSignature,
    setRealPersonAuth: setRealPersonAuth,
    editUserInfo: editUserInfo
};

var ios$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
client: client,
getUid: getUid,
getToken: getToken,
openWeChat: openWeChat,
follow: follow,
getParams: getParams,
closeWebPage: closeWebPage,
share: share,
hasVip: hasVip,
fullScreenTouch: fullScreenTouch,
cancelScreenTouch: cancelScreenTouch,
clientToast: clientToast,
closeGame: closeGame,
sendMsg: sendMsg,
showSendGift: showSendGift,
sharePictureUrl: sharePictureUrl,
openNewWebview: openNewWebview,
setHead: setHead,
setNickname: setNickname,
setTagList: setTagList,
setLocation: setLocation,
setSignature: setSignature,
setRealPersonAuth: setRealPersonAuth,
editUserInfo: editUserInfo,
'default': ios
});

function getUid$1(callback) {
    if (!loveshow.getUid) {
        return callback
            ? callback(0)
            : Promise.reject(0);
    }
    var uid = loveshow.getUid();
    return callback ?
        callback(uid) :
        Promise.resolve(uid);
}
function getToken$1(callback) {
    if (!loveshow.getUserToken) {
        return callback
            ? callback('')
            : Promise.reject('');
    }
    var token = loveshow.getUserToken();
    return callback ?
        callback(token) :
        Promise.resolve(token);
}
function openWeChat$1(callback) {
    if (!loveshow.openWeChat) {
        return callback
            ? callback()
            : Promise.reject();
    }
    return callback ?
        callback(loveshow.openWeChat()) :
        Promise.resolve(loveshow.openWeChat());
}
function follow$1(_a, callback) {
    var hasFollow = _a.hasFollow, uid = _a.uid;
    if (!loveshow.follow) {
        return callback
            ? callback()
            : Promise.reject();
    }
    return callback ?
        callback(loveshow.follow(hasFollow, uid)) :
        Promise.resolve(loveshow.follow(hasFollow, uid));
}
function getParams$1(callback) {
    if (!loveshow.getParams) {
        var params_1 = {
            uid: 0,
            token: '',
            udid: '',
            app: '',
            version: 0,
            channel: '',
            model: '',
            term: 0,
            nettype: 0,
            ts: Date.now()
        };
        return callback ?
            callback(params_1) :
            Promise.reject(params_1);
    }
    var params = JSON.parse(loveshow.getParams());
    return callback ?
        callback(params) :
        Promise.resolve(params);
}
function closeWebPage$1(_a, callback) {
    var url = _a.url;
    if (!loveshow.closeWebPage) {
        return callback
            ? callback()
            : Promise.reject();
    }
    return callback ?
        callback(loveshow.closeWebPage(url)) :
        Promise.resolve(loveshow.closeWebPage(url));
}
function share$1(_a, callback) {
    var shareType = _a.shareType, title = _a.title, content = _a.content, imgUrl = _a.imgUrl, url = _a.url;
    if (!loveshow.share) {
        return callback
            ? callback()
            : Promise.reject();
    }
    return callback ?
        callback(loveshow.share(shareType, title, content, imgUrl, url)) :
        Promise.resolve(loveshow.share(shareType, title, content, imgUrl, url));
}
function hasVip$1(callback) {
    if (!loveshow.hasVip) {
        return callback
            ? callback(false)
            : Promise.reject(false);
    }
    var hasVip = !!((JSON.parse(loveshow.hasVip())).has_vip);
    return callback ?
        callback(hasVip) :
        Promise.resolve(hasVip);
}
function fullScreenTouch$1(callback) {
    if (!loveshow.fullScreenTouch) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.fullScreenTouch()) :
        Promise.resolve(loveshow.fullScreenTouch());
}
function cancelScreenTouch$1(callback) {
    if (!loveshow.cancelScreenTouch) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.cancelScreenTouch()) :
        Promise.resolve(loveshow.cancelScreenTouch());
}
function clientToast$1(_a, callback) {
    var content = _a.content;
    try {
        return callback ?
            callback(loveshow.clientToast(content)) :
            Promise.resolve(loveshow.clientToast(content));
    }
    catch (e) {
        return callback ?
            callback(e) :
            Promise.reject(e);
    }
}
function closeGame$1(callback) {
    if (!loveshow.closeGame) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.closeGame()) :
        Promise.resolve(loveshow.closeGame());
}
function showSendGift$1(_a, callback) {
    var gid = _a.gid;
    if (!loveshow.showSendGift) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.showSendGift(gid)) :
        Promise.resolve(loveshow.showSendGift(gid));
}
function sendMsg$1(_a, callback) {
    var rid = _a.rid, msg = _a.msg;
    if (!loveshow.sendMsg) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.sendMsg(rid, msg)) :
        Promise.resolve(loveshow.sendMsg(rid, msg));
}
function sharePictureUrl$1(_a, callback) {
    var picUrl = _a.picUrl, shareUrl = _a.shareUrl, title = _a.title, content = _a.content;
    if (!loveshow.sharePictureUrl) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.sharePictureUrl(picUrl, shareUrl, title, content)) :
        Promise.resolve(loveshow.sharePictureUrl(picUrl, shareUrl, title, content));
}
function openNewWebview$1(_a, callback) {
    var url = _a.url;
    if (!loveshow.openNewWebview) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.openNewWebview(url)) :
        Promise.resolve(loveshow.openNewWebview(url));
}
function setHead$1(callback) {
    if (!loveshow.setHead) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.setHead()) :
        Promise.resolve(loveshow.setHead());
}
function setNickname$1(callback) {
    if (!loveshow.setNickname) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.setNickname()) :
        Promise.resolve(loveshow.setNickname());
}
function setTagList$1(callback) {
    if (!loveshow.setTagList) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.setTagList()) :
        Promise.resolve(loveshow.setTagList());
}
function setLocation$1(callback) {
    if (!loveshow.setLocation) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.setLocation()) :
        Promise.resolve(loveshow.setLocation());
}
function setSignature$1(callback) {
    if (!loveshow.setSignature) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.setSignature()) :
        Promise.resolve(loveshow.setSignature());
}
function setRealPersonAuth$1(callback) {
    if (!loveshow.setRealPersonAuth) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.setRealPersonAuth()) :
        Promise.resolve(loveshow.setRealPersonAuth());
}
function editUserInfo$1(_a, callback) {
    var tuid = _a.tuid;
    if (!loveshow.editUserInfo) {
        return callback ?
            callback() :
            Promise.reject();
    }
    return callback ?
        callback(loveshow.editUserInfo(tuid)) :
        Promise.resolve(loveshow.editUserInfo(tuid));
}
var android = {
    getUid: getUid$1,
    getToken: getToken$1,
    openWeChat: openWeChat$1,
    follow: follow$1,
    getParams: getParams$1,
    closeWebPage: closeWebPage$1,
    share: share$1,
    hasVip: hasVip$1,
    fullScreenTouch: fullScreenTouch$1,
    cancelScreenTouch: cancelScreenTouch$1,
    clientToast: clientToast$1,
    closeGame: closeGame$1,
    showSendGift: showSendGift$1,
    sendMsg: sendMsg$1,
    sharePictureUrl: sharePictureUrl$1,
    openNewWebview: openNewWebview$1,
    setHead: setHead$1,
    setNickname: setNickname$1,
    setTagList: setTagList$1,
    setLocation: setLocation$1,
    setSignature: setSignature$1,
    setRealPersonAuth: setRealPersonAuth$1,
    editUserInfo: editUserInfo$1
};

var android$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
getUid: getUid$1,
getToken: getToken$1,
openWeChat: openWeChat$1,
follow: follow$1,
getParams: getParams$1,
closeWebPage: closeWebPage$1,
share: share$1,
hasVip: hasVip$1,
fullScreenTouch: fullScreenTouch$1,
cancelScreenTouch: cancelScreenTouch$1,
clientToast: clientToast$1,
closeGame: closeGame$1,
showSendGift: showSendGift$1,
sendMsg: sendMsg$1,
sharePictureUrl: sharePictureUrl$1,
openNewWebview: openNewWebview$1,
setHead: setHead$1,
setNickname: setNickname$1,
setTagList: setTagList$1,
setLocation: setLocation$1,
setSignature: setSignature$1,
setRealPersonAuth: setRealPersonAuth$1,
editUserInfo: editUserInfo$1,
'default': android
});

function getUid$2(callback) {
    return callback
        ? callback(0)
        : Promise.reject(0);
}
function getToken$2(callback) {
    return callback
        ? callback('')
        : Promise.reject('');
}
function openWeChat$2(callback) {
    return callback
        ? callback()
        : Promise.reject();
}
function follow$2(followParams, callback) {
    return callback
        ? callback()
        : Promise.reject();
}
function getParams$2(callback) {
    var params = {
        uid: 0,
        token: '',
        udid: '',
        app: '',
        version: 0,
        channel: '',
        model: '',
        term: 0,
        nettype: 0,
        ts: Date.now()
    };
    return callback ?
        callback(params) :
        Promise.reject(params);
}
function closeWebPage$2(closeWebPageParams, callback) {
    return callback
        ? callback()
        : Promise.reject();
}
function share$2(shareParams, callback) {
    return callback
        ? callback()
        : Promise.reject();
}
function hasVip$2(callback) {
    return callback
        ? callback(false)
        : Promise.reject(false);
}
function fullScreenTouch$2(callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function cancelScreenTouch$2(callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function clientToast$2(clientToastParams, callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function closeGame$2(callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function sendMsg$2(sendMsgParams, callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function showSendGift$2(showSendGiftParams, callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function sharePictureUrl$2(sharePictureUrlParams, callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function openNewWebview$2(openNewWebviewParams, callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function setHead$2(callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function setNickname$2(callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function setTagList$2(callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function setLocation$2(callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function setSignature$2(callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function setRealPersonAuth$2(callback) {
    return callback ?
        callback() :
        Promise.reject();
}
function editUserInfo$2(editUserInfoParams, callback) {
    return callback ?
        callback() :
        Promise.reject();
}
var base = {
    getUid: getUid$2,
    getToken: getToken$2,
    openWeChat: openWeChat$2,
    follow: follow$2,
    getParams: getParams$2,
    closeWebPage: closeWebPage$2,
    share: share$2,
    hasVip: hasVip$2,
    fullScreenTouch: fullScreenTouch$2,
    cancelScreenTouch: cancelScreenTouch$2,
    clientToast: clientToast$2,
    closeGame: closeGame$2,
    sendMsg: sendMsg$2,
    showSendGift: showSendGift$2,
    sharePictureUrl: sharePictureUrl$2,
    openNewWebview: openNewWebview$2,
    setHead: setHead$2,
    setNickname: setNickname$2,
    setTagList: setTagList$2,
    setLocation: setLocation$2,
    setSignature: setSignature$2,
    setRealPersonAuth: setRealPersonAuth$2,
    editUserInfo: editUserInfo$2
};

var base$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
getUid: getUid$2,
getToken: getToken$2,
openWeChat: openWeChat$2,
follow: follow$2,
getParams: getParams$2,
closeWebPage: closeWebPage$2,
share: share$2,
hasVip: hasVip$2,
fullScreenTouch: fullScreenTouch$2,
cancelScreenTouch: cancelScreenTouch$2,
clientToast: clientToast$2,
closeGame: closeGame$2,
sendMsg: sendMsg$2,
showSendGift: showSendGift$2,
sharePictureUrl: sharePictureUrl$2,
openNewWebview: openNewWebview$2,
setHead: setHead$2,
setNickname: setNickname$2,
setTagList: setTagList$2,
setLocation: setLocation$2,
setSignature: setSignature$2,
setRealPersonAuth: setRealPersonAuth$2,
editUserInfo: editUserInfo$2,
'default': base
});

var ShareType;
(function (ShareType) {
    ShareType[ShareType["QQ"] = 0] = "QQ";
    ShareType[ShareType["Wechat"] = 1] = "Wechat";
    ShareType[ShareType["Weibo"] = 2] = "Weibo";
    ShareType[ShareType["Qzone"] = 3] = "Qzone";
    ShareType[ShareType["Moments"] = 4] = "Moments";
})(ShareType || (ShareType = {}));

function getUrlQuery() {
    return parse(location.search.split("?").pop());
}
var _a = client
    ? ios$1
    : typeof loveshow !== 'undefined'
        ? android$1
        : base$1, getUid$3 = _a.getUid, getToken$3 = _a.getToken, openWeChat$3 = _a.openWeChat, follow$3 = _a.follow, getParams$3 = _a.getParams, closeWebPage$3 = _a.closeWebPage, share$3 = _a.share, hasVip$3 = _a.hasVip, fullScreenTouch$3 = _a.fullScreenTouch, cancelScreenTouch$3 = _a.cancelScreenTouch, clientToast$3 = _a.clientToast, closeGame$3 = _a.closeGame, sendMsg$3 = _a.sendMsg, showSendGift$3 = _a.showSendGift, sharePictureUrl$3 = _a.sharePictureUrl, openNewWebview$3 = _a.openNewWebview, setHead$3 = _a.setHead, setNickname$3 = _a.setNickname, setTagList$3 = _a.setTagList, setLocation$3 = _a.setLocation, setSignature$3 = _a.setSignature, setRealPersonAuth$3 = _a.setRealPersonAuth, editUserInfo$3 = _a.editUserInfo;

export { ShareType, cancelScreenTouch$3 as cancelScreenTouch, client, clientToast$3 as clientToast, closeGame$3 as closeGame, closeWebPage$3 as closeWebPage, editUserInfo$3 as editUserInfo, follow$3 as follow, fullScreenTouch$3 as fullScreenTouch, getParams$3 as getParams, getToken$3 as getToken, getUid$3 as getUid, getUrlQuery, hasVip$3 as hasVip, openNewWebview$3 as openNewWebview, openWeChat$3 as openWeChat, sendMsg$3 as sendMsg, setHead$3 as setHead, setLocation$3 as setLocation, setNickname$3 as setNickname, setRealPersonAuth$3 as setRealPersonAuth, setSignature$3 as setSignature, setTagList$3 as setTagList, share$3 as share, sharePictureUrl$3 as sharePictureUrl, showSendGift$3 as showSendGift };
